var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg135(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58008 9.92969H5.58105C5.60413 12.2131 7.40369 14.0709 9.66406 14.1855L9.88574 14.1914H18.7871C17.1866 17.4941 13.8021 19.7715 9.88574 19.7715C4.42599 19.7715 0 15.3455 0 9.88574C1.5158e-05 5.96937 2.27738 2.58488 5.58008 0.984375V9.92969ZM9.88574 0C15.3455 0 19.7715 4.42599 19.7715 9.88574C19.7715 10.4469 19.7217 10.9966 19.6318 11.5322H13.8652C14.0753 11.0251 14.1913 10.4688 14.1914 9.88574C14.1912 7.50792 12.2636 5.57917 9.88574 5.5791C9.30257 5.57911 8.74648 5.69616 8.23926 5.90625V0.138672C8.77483 0.0488622 9.32465 2.17173e-06 9.88574 0Z",
    fill: "#F7941D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg135);
export default __webpack_public_path__ + "static/media/svg135.fab08690f3e2a0b1c273c05126e3db23.svg";
export { ForwardRef as ReactComponent };